import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  paper: {
    justifyContent: "center",
    alignItems: "center",
    width: "80vw",
    height: "80vh",
    maxWidth: "90vw",
    margin: 0,
  },
  backdrop: {
    backgroundColor: "transparent",
  },
};
